import React from 'react';


export default function NotFoundPage(){
    return(
    <div>
        <h1>404 NOT FOUND</h1>
    </div>)
}